import type { RawValue } from '@labrav/common'

import type { CloudMarketplace } from '../../productsListing/types'

export const getInitalCloudMarketplace = (): CloudMarketplace => {
  try {
    if (typeof window !== 'undefined' && window.location) {
      const urlParams = new URLSearchParams(window.location.search)
      const cloudTypeFromUrl = urlParams.get('cloudType')
      if (cloudTypeFromUrl) {
        return cloudTypeFromUrl as CloudMarketplace
      }
    }

    if (typeof localStorage !== 'undefined') {
      const fromLocal = localStorage.getItem('cloudType')
      if (fromLocal) {
        try {
          const parsed = JSON.parse(fromLocal) as RawValue
          if (parsed?.value) {
            return parsed.value as CloudMarketplace
          }
        } catch {
          // If JSON parsing fails, fall through to default
        }
      }
    }
  } catch {
    // If any error occurs, fall through to default
  }

  return 'AWS'
}
